import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  async getEnabledTaxStates() {
    return await axios.get(`${BASE_API}/settings/tax-exempt-states`).then(result => result.data ).catch(error => { console.error(error) })
  },
  getUnviewedOrdersCount() {
    return axios
      .get(`${BASE_API}/fishbowl/order/unviewed/`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
        return 0;
      });
  },
  getUnviewedOrders(page) {
    return axios
      .get(`${BASE_API}/fishbowl/order/unviewed/${page}`)
      .then(response => response.data.filter(x => x).map(order => ({
        dateCreated: order.datecreated,
        orderNum: order.ordernum,
        paymentMethod: order.paymentterms,
        totalPrice: order.totalPrice * 100,
        carrier: order.carrier,
        orderNotes: order.note,
      })))
      .catch((error) => {
        console.error(error);
        return [];
      });
  },
  async buildHcItems(id, type, qty, hcOrder, hcProduct, hcNotes, sendFromStock, addReturnItem, itemNum) {
    let items = [{
      product: type,
      description: "Happy Customer Item",
      note: `[Problem on Order: ${hcOrder}][Problem Product: ${hcProduct}][Problem Notes: ${hcNotes}]`,
      rmaHcQty: qty,
      type: 10,
      isHc: true,
      hcId: id
    }];

    if (sendFromStock || addReturnItem) {
      console.log(`searching ${itemNum}`)
      return await axios.get(`${BASE_API}/fishbowl/product/${itemNum}`).then((result) => {
        let x = result.data[0];
        let item = {
          id: x.id,
          product: x.num,
          description: x.description,
          rmaHcQty: qty,
          unitPrice: 0,
          taxableFlag : false,
          isHc: true,
          forceAdded: true,
          forceAddedId: id,
          kitFlag: x.kitFlag,
          kitItems: x.kitItems
        }

        if (addReturnItem) {
          item.type = 20;
          items.push(JSON.parse(JSON.stringify(item)));
        }
        if (sendFromStock) {
          item.type = 10;
          items.push(item);
        }
      }).then(() => {
        return items
      });
    } else {
      return items;
    }
  },
  lockMessage(role, itAccess) {
    return `This page is restricted to the '${role}' role only. ${ itAccess ? "For more information, check the info_settings database" : "If you believe you should have access to this page, please let IT know" }`
  },
};



// WEBPACK FOOTER //
// /src/services/info.js